import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

import {
  type AgentSearchFacets,
  parseFacetQuery,
} from '@/helpers/AgentDirectory/agentFacetRouteParams';

export const useDirectoryRouteFacets = (): ComputedRef<AgentSearchFacets> => {
  const route = useRoute();

  return computed(() => parseFacetQuery(route.query));
};
